import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCalendarPen = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 15 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.688 0c.518 0 .937.419.937.938v.937h3.75V.937a.936.936 0 1 1 1.875 0v.938h1.406c.777 0 1.406.63 1.406 1.406v1.406H.938V3.282c0-.776.63-1.406 1.406-1.406H3.75V.937C3.75.42 4.169 0 4.688 0ZM.938 5.625h13.124v7.969c0 .776-.63 1.406-1.406 1.406H2.344c-.777 0-1.406-.63-1.406-1.406V5.625Zm9.046 2.197c-.43-.43-1.13-.43-1.561 0l-.437.44 1.562 1.561.436-.436c.431-.431.431-1.131 0-1.562v-.003ZM5.218 11.03a.928.928 0 0 0-.246.437l-.27 1.072a.464.464 0 0 0 .123.445.464.464 0 0 0 .446.123l1.072-.27a.942.942 0 0 0 .436-.245l2.107-2.107-1.562-1.561-2.106 2.106Z"
	})
});
export default SvgIconCalendarPen;
